export class FlightDetails {
  reservationCode: string
  bookedLegCollection: BookedLegCollection[]
  warnings: any

  constructor(obj) {
    this.reservationCode = obj?.reservationCode;
    this.bookedLegCollection = obj?.bookedLegCollection;
    this.warnings = obj?.warnings;
  }
}


export class BookedLegCollection {
  segmentCode: string
  departureAirport: string
  departureDate: string
  departureTime: string
  scheduledDepartureDate: string
  scheduledDepartureTime: string
  estimatedDepartureDate: string
  estimatedDepartureTime: string
  departureGate: string
  operatingCarrier: string
  operatingFlightCode: string
  boardingTime: string
  arrivalDate: string
  arrivalTime: string
  scheduledArrivalTime: string
  estimatedArrivalDate: string
  estimatedArrivalTime: string
  flightStatus: string
  cabinInfoList: CabinInfoList[]

  constructor(obj:any) {
    this.cabinInfoList = obj?.cabinInfoList;
  }
}

export class CabinInfoList {
  authorized: number
  classOfService: string
  booked: number
  available: number
  thru: number
  local: number
  nonRevenueLocal: number
  nonRevenueThru: number
}
